import { css } from "@emotion/react"
import hash from "@emotion/hash"

export const pageGradientVar = `--${hash("page:color-set:gradient")}`
export const darkestColor = `--${hash("page:color-set:darkest")}`
export const lightestColor = `--${hash("page:color-set:lightest")}`
export const fontColorVar = `--${hash("page:color-set:font")}`

export const colors = css`
  .pcs${hash("page-color-set-rolex-v7-color-001")} {
    ${fontColorVar}: rgb(231 195 182);
    ${darkestColor}: rgb(54 32 25);
    ${lightestColor}: rgb(156 102 83);
    ${pageGradientVar}: linear-gradient(55deg, rgb(54 32 25), rgb(156 102 83));
  }

  .pcs${hash("page-color-set-rolex-v7-color-002")} {
    ${fontColorVar}: rgb(255 224 227);
    ${darkestColor}: rgb(93 69 69);
    ${lightestColor}: rgb(230 189 193);
    ${pageGradientVar}: linear-gradient(55deg, rgb(93 69 69), rgb(230 189 193));
  }

  .pcs${hash("page-color-set-rolex-v7-color-003")} {
    ${fontColorVar}: rgb(228 198 201);
    ${darkestColor}: rgb(93 69 69);
    ${lightestColor}: rgb(205 166 170);
    ${pageGradientVar}: linear-gradient(55deg, rgb(93 69 69), rgb(205 166 170));
  }

  .pcs${hash("page-color-set-rolex-v7-color-004")} {
    ${fontColorVar}: rgb(247 230 195);
    ${darkestColor}: rgb(60 51 35);
    ${lightestColor}: rgb(156 126 85);
    ${pageGradientVar}: linear-gradient(55deg, rgb(60 51 35), rgb(156 126 85));
  }

  .pcs${hash("page-color-set-rolex-v7-color-005")} {
    ${fontColorVar}: rgb(241 230 203);
    ${darkestColor}: rgb(85 80 69);
    ${lightestColor}: rgb(197 185 155);
    ${pageGradientVar}: linear-gradient(55deg, rgb(85 80 69), rgb(197 185 155));
  }

  .pcs${hash("page-color-set-rolex-v7-color-006")} {
    ${fontColorVar}: rgb(247 231 216);
    ${darkestColor}: rgb(67 66 61);
    ${lightestColor}: rgb(198 195 187);
    ${pageGradientVar}: linear-gradient(55deg, rgb(67 66 61), rgb(198 195 187));
  }

  .pcs${hash("page-color-set-rolex-v7-color-007")} {
    ${fontColorVar}: rgb(157 163 165);
    ${darkestColor}: rgb(24 31 41);
    ${lightestColor}: rgb(81 90 95);
    ${pageGradientVar}: linear-gradient(55deg, rgb(24 31 41), rgb(81 90 95));
  }

  .pcs${hash("page-color-set-rolex-v7-color-008")} {
    ${fontColorVar}: rgb(204 204 204);
    ${darkestColor}: rgb(54 55 54);
    ${lightestColor}: rgb(162 164 163);
    ${pageGradientVar}: linear-gradient(55deg, rgb(54 55 54), rgb(162 164 163));
  }

  .pcs${hash("page-color-set-rolex-v7-color-009")} {
    ${fontColorVar}: rgb(204 204 204);
    ${darkestColor}: rgb(54 54 54);
    ${lightestColor}: rgb(162 164 163);
    ${pageGradientVar}: linear-gradient(55deg, rgb(54 54 54), rgb(162 164 163));
  }

  .pcs${hash("page-color-set-rolex-v7-color-010")} {
    ${fontColorVar}: rgb(218 198 188);
    ${darkestColor}: rgb(54 46 42);
    ${lightestColor}: rgb(147 130 120);
    ${pageGradientVar}: linear-gradient(55deg, rgb(54 46 42), rgb(147 130 120));
  }

  .pcs${hash("page-color-set-rolex-v7-color-011")} {
    ${fontColorVar}: rgb(203 193 228);
    ${darkestColor}: rgb(35 29 47);
    ${lightestColor}: rgb(133 118 172);
    ${pageGradientVar}: linear-gradient(55deg, rgb(35 29 47), rgb(133 118 172));
  }

  .pcs${hash("page-color-set-rolex-v7-color-012")} {
    ${fontColorVar}: rgb(164 204 174);
    ${darkestColor}: rgb(26 37 27);
    ${lightestColor}: rgb(66 105 75);
    ${pageGradientVar}: linear-gradient(55deg, rgb(26 37 27), rgb(66 105 75));
  }

  .pcs${hash("page-color-set-rolex-v7-color-013")} {
    ${fontColorVar}: rgb(142 172 223);
    ${darkestColor}: rgb(5 22 58);
    ${lightestColor}: rgb(33 60 95);
    ${pageGradientVar}: linear-gradient(55deg, rgb(5 22 58), rgb(33 60 95));
  }

  .pcs${hash("page-color-set-rolex-v7-color-014")} {
    ${fontColorVar}: rgb(210 233 254);
    ${darkestColor}: rgb(28 48 53);
    ${lightestColor}: rgb(99 137 157);
    ${pageGradientVar}: linear-gradient(55deg, rgb(39 69 76), rgb(127 190 205));
  }

  .pcs${hash("page-color-set-rolex-v7-color-015")} {
    ${fontColorVar}: rgb(164 164 177);
    ${darkestColor}: rgb(10 10 10);
    ${lightestColor}: rgb(61 61 64);
    ${pageGradientVar}: linear-gradient(55deg, rgb(10 10 10), rgb(61 61 64));
  }

  .pcs${hash("page-color-set-rolex-v7-color-016")} {
    ${fontColorVar}: rgb(208 191 163);
    ${darkestColor}: rgb(21 18 10);
    ${lightestColor}: rgb(90 72 43);
    ${pageGradientVar}: linear-gradient(55deg, rgb(21 18 10), rgb(90 72 43));
  }

  .pcs${hash("page-color-set-rolex-v7-color-017")} {
    ${fontColorVar}: rgb(197 154 139);
    ${darkestColor}: rgb(34 21 15);
    ${lightestColor}: rgb(87 51 37);
    ${pageGradientVar}: linear-gradient(55deg, rgb(34 21 15), rgb(87 51 37));
  }

  .pcs${hash("page-color-set-rolex-v7-color-018")} {
    ${fontColorVar}: rgb(208, 162, 100);
    ${darkestColor}: rgb(127, 49, 17);
    ${lightestColor}: rgb(191, 130, 71);
    ${pageGradientVar}: linear-gradient(55deg, rgb(127, 49, 17), rgb(191, 130, 71));
  }

  .pcs${hash("page-color-set-rolex-v7-color-019")} {
    ${fontColorVar}: rgb(208, 136, 136);
    ${darkestColor}: rgb(71, 5, 6);
    ${lightestColor}: rgb(111, 16, 24);
    ${pageGradientVar}: linear-gradient(55deg, rgb(71, 5, 6), rgb(111, 16, 24));
  }

  .pcs${hash("page-color-set-rolex-v7-color-020")} {
    ${fontColorVar}: rgb(190, 220, 198);
    ${darkestColor}: rgb(37, 60, 33);
    ${lightestColor}: rgb(131, 149, 113);
    ${pageGradientVar}: linear-gradient(55deg, rgb(37, 60, 33), rgb(131, 149, 113));
  }
`
